import { doc, onSnapshot, serverTimestamp, setDoc } from 'firebase/firestore'
import { db } from '../lib/firebase'
import { trackWrite } from '../utils/syncTracker'

/**
 * Notifikationsvalg pr. bruger: adminPrefs/{uid}.
 * Bevidst IKKE i settings/, fordi den samling kan læses offentligt.
 */
export interface NotificationPrefs {
  /** Én daglig påmindelse, hvis der ikke er registreret timer på dagens sag. */
  hoursReminder: boolean
  /** Påmindelser mens en timer stadig kører (efter 2 timer og derefter hver 2. time). */
  timerReminder: boolean
}

export const defaultPrefs: NotificationPrefs = { hoursReminder: false, timerReminder: false }

const prefsRef = (uid: string) => doc(db, 'adminPrefs', uid)

export function subscribePrefs(
  uid: string,
  onChange: (prefs: NotificationPrefs) => void,
  onError: (error: unknown) => void,
): () => void {
  return onSnapshot(
    prefsRef(uid),
    (snapshot) => {
      const data = snapshot.data() ?? {}
      onChange({
        hoursReminder: data.hoursReminder === true,
        timerReminder: data.timerReminder === true,
      })
    },
    onError,
  )
}

export function savePrefs(uid: string, patch: Partial<NotificationPrefs>): Promise<void> {
  return trackWrite(setDoc(prefsRef(uid), { ...patch, updatedAt: serverTimestamp() }, { merge: true }))
}
